/**
 * @deprecated use the `StyleSpace` typescript type for type safety
 */ const SPACING_SIZES = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13
];
/**
 * @deprecated use exported js tokens directly (ex SpacingStandard4)
 */ const SPACING = {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 40,
    8: 48,
    9: 64,
    10: 80,
    11: 96,
    12: 128,
    13: 160
};
/**
 * @deprecated use exported js tokens directly (ex SpacingStandard4)
 */ const SPACING_PX = {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '24px',
    6: '32px',
    7: '40px',
    8: '48px',
    9: '64px',
    10: '80px',
    11: '96px',
    12: '128px',
    13: '160px'
};

export { SPACING, SPACING_PX, SPACING_SIZES };
